import React from "react";

import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import {
  TableSortLabel as MuiTableSortLabel,
  TableSortLabelProps,
} from "@mui/material";

const getIcon = (
  active: TableSortLabelProps["active"],
  direction: TableSortLabelProps["direction"]
) => {
  if (!active) {
    return UnfoldMoreIcon;
  }

  switch (direction) {
    case "asc":
      return ArrowUpwardIcon;
    case "desc":
      return ArrowDownwardIcon;
    default:
      return;
  }
};

const TableSortLabel = React.forwardRef<HTMLElement, TableSortLabelProps>(
  ({ active, children, direction, sx, ...sortLabelProps }, ref) => {
    const Icon = getIcon(active, direction);
    return (
      <MuiTableSortLabel
        {...sortLabelProps}
        direction={direction}
        IconComponent={
          Icon
            ? () => (
                <Icon
                  sx={{
                    width: "18px",
                    height: "18px",
                    mx: "4px",
                    color: "shades.neutral.300",
                    transition: "all 0.1s ease",
                  }}
                />
              )
            : undefined
        }
        sx={{
          "& path": {
            color: active ? "chart.purple.dark" : "shades.neutral.300",
          },
          ...sx,
        }}
        ref={ref}
      >
        {children}
      </MuiTableSortLabel>
    );
  }
);

TableSortLabel.displayName = "TableSortLabel";

export default TableSortLabel;
